var _path, _path2, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGroup3419({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 47,
    height: 47,
    viewBox: "0 0 47 47",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.666 26.9686L24.5589 23.6087L15.666 20.1528V15.449L30.8975 21.6888V25.5286L15.666 31.7684V26.9686Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M36.1562 19.5834H46.6751C44.8105 8.46898 35.1443 0 23.5 0C10.5213 0 0 10.5213 0 23.5C0 36.4787 10.5213 47 23.5 47C35.1442 47 44.8104 38.5311 46.6751 27.4167H36.2227C35.2527 30.6904 33.0642 33.4404 30.1827 35.1412L21.2144 43.0833V36.8147C14.8586 35.7754 10.0083 30.2585 10.0083 23.6088C10.0083 16.2182 15.9996 10.2269 23.3903 10.2269C29.3783 10.2269 34.4476 14.1598 36.1562 19.5834Z",
    fill: "url(#paint0_linear_1543_3917)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1543_3917",
    x1: 23.3375,
    y1: 0,
    x2: 23.3375,
    y2: 47,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#73DAF9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0390DF"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGroup3419);
export default __webpack_public_path__ + "static/media/Group 3419.1f64b0569d1f2fddda6746c5a22407fd.svg";
export { ForwardRef as ReactComponent };